// react
import { useCallback, useEffect, useMemo } from 'react';
import styled from 'styled-components';

// components
import { Container } from '@/components/atoms';
import { TOS } from '@/components/molecules';
import { Icons } from '@/components/atoms/Icon/icons';
import {
  GenericFlowProps,
  OnboardingActions,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';

type BgColors = 'blue' | 'red' | 'green' | 'yellow';

export const OnboardingTOS = toGenericOnboarding(
  ({
    setIsNextDisabled,
    config,
  }: GenericFlowProps<OnboardingTOSConfigItem>) => {
    // memos
    const isComplete = useMemo(() => {
      const fields = Object.values(
        config?.[0]?.consentForm?.fields || {},
      )?.[0] as any;
      const val = config?.[0]?.value?.[fields?.id];

      if (val === undefined || val === null || val === '') {
        return false;
      }

      const options = fields?.field?.options || [];

      return JSON.parse(val).length >= options.length;
    }, [config?.[0]?.value]);

    // effects
    useEffect(() => {
      setIsNextDisabled(!isComplete);
    }, [isComplete]);

    return (
      <Container size='md'>
        <Wrapper>
          {config?.[0]?.consentForm?.fields && (
            <TOS
              consent={config?.[0]?.value}
              setConsent={config?.[0]?.setValue}
              consentFields={config?.[0]?.consentForm?.fields}
            />
          )}
        </Wrapper>
      </Container>
    );
  },
);

const Wrapper = styled.div`
  height: 100%;
  padding: ${(props) => props.theme.spacing[32]} 0;
`;

export interface OnboardingTOSConfigItem extends OnboardingActions {
  id: string;
  icon: Icons;
  text: string;
  subtext?: string;
  color: BgColors;
  confetti?: boolean;
  ctaButtonLabel: string;
  ctaButtonPath?: string;
  value: any;
  setValue: (v: any) => void;
  consentForm: any;
}

OnboardingTOS.displayName = 'OnboardingTOS';
export default toGenericOnboarding(OnboardingTOS);
